const GROUPS_ABLE_TO_SUPERVISE = ['Manager', 'UpperManagement', 'EducationDirectorAdminAssistant', 'Director'];

const filterEligibleSupervisors = (staff: any[]): any[] =>
  (staff || []).filter((emp: any) => {
    if (emp?.group?.name === '"UpperManagement"') {
      return true;
    }
    return GROUPS_ABLE_TO_SUPERVISE.includes(emp?.group?.name) || emp?.roles?.includes('admin');
  });

export default filterEligibleSupervisors;
